module.exports = __webpack_public_path__ + "img/GdGkBmXm.03e0c3e1.webp";